<template>
  <v-card class="pa-20px card-item sumar-item" @click="select" :class="odoslanyNaSchvalenie ? 'sumar-item-odoslany' : ''">
    <v-overlay
      :absolute="true"
      opacity="0.5"
      :color="this.$vuetify.theme.dark ? '#2C2E34' : '#FFFFFF'"
      :value="!value.enabled"
      :z-index="1"
    >
    </v-overlay>
    <div  class="mb-10px" v-if="showStav" style="z-index: 1">
      <!-- TODO fajka a stav sa prekryvaju -->
      <status :state="mapColor(value.id_farby)" custom
        >{{ value.stav
        }}<template v-if="jeDealer && (value.iur || value.poznamka)">
          <v-tooltip top :close-delay="0" :open-delay="200">
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                class="btn-help poznamka-icon"
                @click.stop="$emit('nastavPoznamku', value)"
              >
                mdi-alert-circle
              </v-icon>
            </template>
            <span>Poznámka</span>
          </v-tooltip>
        </template></status
      >
    </div>

    <template v-if="row">
      <div class="d-flex">
        <div v-if="showArrow" class="sumar-item-arrow-color pr-4">
          <v-icon @click="toggleShowMore" :class="{'rotate-180': showMoreItems}" style="z-index: 1">mdi-chevron-down</v-icon>
        </div>
        <div class="d-flex flex-column" :class="{ 'pl-10' : !showArrow }">
          <div class="d-flex text-group-size">
            <text-group
              v-if="value.nazov_produktu != null"
              class="pr-16px"
              :utext="value.druh_financovania"
              :btext="value.nazov_produktu"
              smallHeader
              large
            ></text-group>
            <text-group
              v-if="value.akontacia_perc != null"
              utext="Akontácia"
              class="px-16px"
              :btext="value.akontacia_perc >= 0 ? value.akontacia_perc.toSkString() : ''"
              smallHeader
            ></text-group>
            <text-group
              v-if="value.platba_pri_podpise != null"
              utext="Platba pri podpise"
              class="px-16px"
              :btext="value.platba_pri_podpise >= 0 ? value.platba_pri_podpise.toEurString() : ''"
              smallHeader
            ></text-group>
            <text-group
              v-if="value.tenor != null"
              class="px-16px"
              utext="Dĺžka splácania"
              :btext="value.tenor >= 0 ? value.tenor.formatSuffix(' mesiacov') : ''"
              smallHeader
            ></text-group>
            <text-group
              v-if="value.splatka != null"
              class="pl-16px"
              utext="Splátka"
              :btext="value.splatka >= 0 ? value.splatka.toEurString() : ''"
              smallHeader
            ></text-group>
          </div>
          <div v-if="showMoreItems" class="d-flex pt-2 text-group-size">
            <text-group
              v-if="value.vyska_uveru != null"
              class="pr-16px"
              utext="Celková výška spotrebiteľského úveru"
              :btext="value.vyska_uveru >= 0 ? value.vyska_uveru.toEurString() : ''"
              smallHeader
            ></text-group>
            <text-group
              v-if="value.celkova_suma != null"
              class="px-16px"
              utext="Celková čiastka hradená spotrebiteľom"
              :btext="value.celkova_suma >= 0 ? value.celkova_suma.toEurString() : ''"
              smallHeader
            ></text-group>
            <text-group
              v-if="value.klientsky_urok != null"
              class="px-16px"
              utext="Klientsky úrok"
              :btext="value.klientsky_urok >= 0 ? value.klientsky_urok.toPercentString() : ''"
              smallHeader
            ></text-group>
            <text-group
              v-if="value.rpmn != null"
              class="pl-16px"
              utext="RPMN"
              :btext="value.rpmn >= 0 ? value.rpmn.toPercentString() : ''"
              smallHeader
            ></text-group>
          </div>
        </div>
        <div 
          v-if="value.poznamka != null"
          class="d-flex pt-6px ml-auto pr-3"
          style="z-index: 2;">
          <a 
          class="bold sumar-item-arrow-color"
          @click="openSuhlasDialog" 
          style="font-size: 15px; white-space: nowrap">
            Súhlas s podmienkami
            <v-icon>mdi-chevron-right</v-icon>
        </a>
        </div>
        <div 
        :class="{ 'ml-auto' : (value.poznamka == null) }">
          <v-btn
            v-if="pravoNaAdresnuPonuku"
            class="btn-secondary"
            :disabled="!value.enabled_schvalenie"
            @click="odoslatNaSchvalenie"
            >Odoslať na schválenie</v-btn
          > 
        </div>
      </div>
    </template>
    <template v-else>
      <text-group
        class="mt-10px variant-nazov"
        :utext="value.druh_financovania"
        :btext="value.nazov_produktu"
        smallHeader
        large
      ></text-group>
      <template v-if="!value.olfs">
        <div class="d-flex mt-12px">
          <text-group
            class="w50"
            utext="Akontácia %"
            :btext="value.akontacia_perc >= 0 ? value.akontacia_perc.toSkString() : ''"
            smallHeader
          ></text-group>
          <text-group
            v-if="value.platba_pri_podpise != null"
            class="w50"
            utext="Platba pri podpise"
            :btext="value.platba_pri_podpise >= 0 ? value.platba_pri_podpise.toEurString() : ''"
            smallHeader
          ></text-group>
        </div>
        <v-divider class="my-8px"></v-divider>
      </template>
      <div class="d-flex flex-grow-1">
        <text-group class="w50" utext="Dĺžka splácania" :btext="value.tenor.getTenor()" smallHeader></text-group>
        <text-group
          v-if="value.splatka != null"
          class="w50"
          utext="Splátka"
          :btext="value.splatka >= 0 ? value.splatka.toEurString() : ''"
          smallHeader
        ></text-group>
      </div>
      <template v-if="value.olfs">
        <v-divider class="my-8px"></v-divider>
        <div class="d-flex flex-grow-1">
          <text-group class="w100" utext="Nájazd" :btext="value.najazd" smallHeader></text-group>
          <div class="w100" style="text-align:end; align-content: center;">
            <v-icon color="primary"  @click.stop="$emit('openPorovnanieBalikovDialog')"> $detail_zmluvy </v-icon>
          </div>
        </div>
      </template>
      <template v-else>
        <v-divider v-show="value.zv_spl_koniec_suma" class="my-8px"></v-divider>
        <text-group
          v-show="value.zv_spl_koniec_suma"
          class="mt-2 white100"
          style="text-align: center"
          utext="Posledná zvýšená splátka (%/suma)"
          :btext="
            value.zv_spl_koniec_suma
              ? value.zv_spl_koniec_perc.toPercentString(2) +
                '/' +
                value.zv_spl_koniec_suma.toEurString()
              : ''
          "
          smallHeader
        ></text-group>
        <v-divider v-show="value.zost_hodnota_suma" class="my-8px"></v-divider>
        <text-group
          v-show="value.zost_hodnota_suma"
          class="mt-2 white100"
          style="text-align: center"
          utext="Zostatková hodnota (%/suma)"
          :btext="
            value.zost_hodnota_suma
              ? value.zost_hodnota_perc.toPercentString(2) + '/' + value.zost_hodnota_suma.toEurString()
              : ''
          "
          smallHeader
        ></text-group>
        <v-divider class="my-8px" v-show="false"></v-divider>
        <text-group
          class="mt-2 white100"
          style="text-align: center"
          utext="Celková cena leasingu s DPH"
          :btext="value.lo_s_dph >= 0 ? value.lo_s_dph.toEurString() : ''"
          smallHeader
          hidden
        ></text-group>
        
        <template v-if="formaPodnikania.pkId == 3">
          <v-divider class="my-8px"></v-divider>
          <text-group
            class="mt-2 white100"
            style="text-align: center"
            utext="Celková výška spotrebiteľského úveru"
            :btext="value.vyska_uveru >= 0 ? value.vyska_uveru.toEurString() : ''"
            smallHeader
          ></text-group>
          <v-divider class="my-8px"></v-divider>
          <text-group
            class="mt-2 white100"
            style="text-align: center"
            utext="Celková čiastka hradená spotrebiteľom"
            :btext="value.celkova_suma >= 0 ? value.celkova_suma.toEurString() : ''"
            smallHeader
          ></text-group>
        </template>
      </template> 
    </template>
  </v-card>
</template>
<script>
import Status from '../basic/Status.vue';
import TextGroup from '../basic/TextGroup.vue';
import protectedAxios from '../../auth/axios';
import { mapGetters, mapMutations } from 'vuex';
  
export default {
  components: {
    Status,
    TextGroup,
  },
  props: {
    value: Object,
    pravoNaAdresnuPonuku: Boolean,
    jeDealer: Boolean,
    jePrihlaseny: Boolean,
    row: {
      type: Boolean,
      default: false,
    },
    formaPodnikania: Object
  },
  data: () => ({
      showMoreItems: false,
    }),
    async mounted() {
    },
  methods: {
    ...mapMutations(['openDialog','closeDialog']),
    mapColor(idFarby) {
      //podla cis_color co je semafor, to namapujem na pouzite farby pre komponent status
      //1 - zelena
      //2 - oranzova
      //3 - cervena

      switch (idFarby) {
        case 1:
          return 2;
        case 2:
          return 3;
        case 3:
          return 5;

        default:
          return 100;
      }
    },
    async select() {
      if(this.value.enabled)
        this.$emit("select",this.value);
    },
    odoslatNaSchvalenie() {
      this.$emit('odoslatClick');
    },
    openSuhlasDialog() {
      let dialog = {
          persistent: true,
          header: `<span class="gs100 f16">Podmienky financovania</span>`,
          text: `<span class="f16 bold white100">Vami zvolená ponuka môže byť schválená po splnení nasledujúcich podmienok:<br/><br/></span>
                  <span class="f16">${this.value.poznamka}</span>`,
          closeIcon: {
            value: true,
          },
          primaryBtn: {
            text: `Oboznámil/a som sa a súhlasím`,
            func: this.suhlasVariantu,
            disabled: this.value.enabled_schvalenie == 1 ? true : false
          },
          closeBtn: {
            value: true,
            text: 'Nesúhlasím',
            disabled: this.value.enabled_schvalenie == 1 ? true : false
          },
        };

        this.openDialog(dialog);
    },
    toggleShowMore() {
      this.showMoreItems = !this.showMoreItems;
    },
    async suhlasVariantu(){
      return await protectedAxios.post(
          `sumar/SuhlasVariantu`,
          {
            NewId: this.pripad.newId,
            IdIur: this.value.id_iur,
            PkIdLsd: this.value.pkid_lsd,
            PkIdLsv: this.value.pkid_lsv,
          })
        .catch(e => {
          console.error(e);
        }).
        finally(()=>{
          this.$emit("reloadPonuknuteVarianty")
          this.closeDialog();
        });
    }
  },
  computed: {
    ...mapGetters(['pripad']),
    showStav() {
      return this.value.id_farby != null ? (this.jeDealer ? true : (this.jePrihlaseny ? (this.formaPodnikania.pkId == 1 || this.formaPodnikania.pkId == 2) : false)) : false;
    },
    showArrow() {
      return this.value.vyska_uveru != null && this.value.celkova_suma != null && this.value.klientsky_urok != null && this.value.rpmn != null;
    },
    odoslanyNaSchvalenie() {
      return (this.value.oznaceny == 0 && this.value.odoslany_na_schvalenie == 1 ) || (this.row && this.value.enabled == 0);
    }
  }
};
</script>
<style lang="sass">
.variant-nazov
  min-height: 54px
</style>
